import { collection, addDoc, serverTimestamp, getDocs } from "firebase/firestore";
import { db } from "./config";

/**
 * Submits contact form data to Firestore
 * @param {Object} formData - The contact form data
 * @returns {Promise} - Promise that resolves with the document reference
 */
export const submitContactForm = async (formData) => {
  try {    
    // Ensure we have a valid db connection
    if (!db) {
      console.error("Firebase database connection is not established");
      return { success: false, error: "Database connection error" };
    }
    
    // Create a sanitized version of the data (remove any undefined/null values)
    const sanitizedData = Object.entries(formData).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    const contactsRef = collection(db, "contacts");
    
    // Add timestamp to the form data
    const dataToSubmit = {
      ...sanitizedData,
      createdAt: serverTimestamp(),
    };
        
    const docRef = await addDoc(contactsRef, dataToSubmit);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error submitting contact form:", error);
    return { 
      success: false, 
      error: error.message || "Unknown error occurred during form submission" 
    };
  }
};

export const getWebsiteTexts = async () => {
  try {
    const textsRef = collection(db, "website-texts");
    const snapshot = await getDocs(textsRef);
    const texts = snapshot.docs.map(doc => {return {"id": doc.id, "data": doc.data()}});
    return texts;
  } catch (error) {
    console.error("Error fetching website texts:", error);
    return [];
  }
};
  